import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface SlackInstallUrlResponse {
  success: boolean;
  authorization_url: string;
}

export const useSlackInstallUrl = (): UseMutationResult<string, Error, number> => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useMutation({
    mutationFn: async (workspaceId: number): Promise<string> => {
      const res = await fetch(ENDPOINTS.slack.install(workspaceId), {
        method: "GET",
        headers: jsonAuthHeaders(userToken),
      });
      const body: SlackInstallUrlResponse = await handleResponse(res);
      return body.authorization_url;
    },
  });
};
